import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from '../services/base.service';
import { TeacherService } from '../services/teacher.service';

@Injectable({
    providedIn: 'root'
})
export class TeacherResolver implements Resolve<ApiObjectData> {
    constructor(
        private service: TeacherService,
        private baseService: BaseService
    ) { }
    resolve(route: ActivatedRouteSnapshot): Observable<ApiObjectData> {
        return this.baseService.resolveGet(this.service, route, '/page/teachers');
    }
}

@Injectable({
    providedIn: 'root'
})
export class TeachersResolver implements Resolve<ApiObjectData> {
    constructor(
        private service: TeacherService,
        private baseService: BaseService
    ) { }
    resolve(): Observable<ApiObjectData> {
        return this.baseService.resolveGets(this.service);
    }
}